import { z } from 'zod'
import type { StockERPSettings } from '../../models/StockERPSettings'
import { StockRecountERPSettingsDTO, mapStockRecountERPSettingsToDTO, mapDTOToStockRecountERPSettings } from './StockRecountERPSettingsDTO'

export const StockERPSettingsDTO = z.object({
  allow_negative_stock: z.boolean().nullable().optional(),
  show_negative_warning: z.boolean().nullable().optional(),
  allow_product_value_changes: z.boolean().optional(),
  prioritize_movement_cost: z.boolean().optional(),
  recount_settings: StockRecountERPSettingsDTO.optional()
})

export type StockERPSettingsDTO = z.infer<typeof StockERPSettingsDTO>

export function mapStockERPSettingsToDTO (model: StockERPSettings): StockERPSettingsDTO {
  return {
    allow_negative_stock: model.allowNegativeStock,
    show_negative_warning: model.showNegativeWarning,
    allow_product_value_changes: model.allowProductValueChanges,
    prioritize_movement_cost: model.prioritizeMovementCost,
    recount_settings: model.recountSettings ? mapStockRecountERPSettingsToDTO(model.recountSettings) : undefined
  }
}

export function mapDTOToStockERPSettings (dto: StockERPSettingsDTO): StockERPSettings {
  return {
    allowNegativeStock: dto.allow_negative_stock ?? undefined,
    showNegativeWarning: dto.show_negative_warning ?? undefined,
    allowProductValueChanges: dto.allow_product_value_changes,
    prioritizeMovementCost: dto.prioritize_movement_cost,
    recountSettings: dto.recount_settings ? mapDTOToStockRecountERPSettings(dto.recount_settings) : undefined
  }
}
